export default function NavBar() {
  return (
    <nav>
      <ul className="navbar">
        <li>
          <a href="/">Home</a>
        </li>
      </ul>
    </nav>
  );
}
